/* eslint-disable max-statements */
import React from 'react';
import cn from 'classnames';

const NestableItem = ({ item, isCopy, options, index, isAndItem, isOrItem, isDraggableItem, singleRow }) => {
  const { dragItem, renderItem, handler, childrenProp } = options;

  const isCollapsed = options.isCollapsed(item);
  const isDragging = !isCopy && dragItem && dragItem.id === item.id;
  const hasChildren = item[childrenProp] && item[childrenProp].length > 0;

  let Handler;
  const isOrGroup =
    item.element.type === 'group' && (item.element.condition === '' || item.element.condition === false);
  const isAndGroup =
    item.element.type === 'group' && !(item.element.condition === '' || item.element.condition === false);

  const itemProps = {
    className: cn(
      `nestable-item${isCopy ? '-copy' : ''}`,
      `nestable-item${isCopy ? '-copy' : ''}-${item.id}`,
      `nestable-item-type-${item.element.type}`,
      {
        'is-or-group': isOrGroup,
        'is-and-group': isAndGroup,
        'is-and-filter': item.element.type === 'filter' && isAndItem,
        'is-or-filter': item.element.type === 'filter' && isOrItem,
      },
      {
        'is-dragging': isDragging,
      },
    ),
  };

  let rowProps = {};
  let handlerProps = {};
  if (!isCopy) {
    if (dragItem) {
      rowProps = {
        ...rowProps,
        onMouseEnter: (e) => options.onMouseEnter(e, item),
      };
    } else {
      handlerProps = {
        ...handlerProps,
        draggable: isDraggableItem !== false,
        onDragStart: (e) => options.onDragStart(e, item),
      };
    }
  }

  if (handler) {
    Handler = (
      <span className="nestable-item-handler" {...handlerProps}>
        {handler}
      </span>
    );
    // Handler = React.cloneElement(handler, handlerProps);
  } else {
    rowProps = {
      ...rowProps,
      ...handlerProps,
    };
  }

  const childLength = item[childrenProp].length;
  let childClass = 'single';
  if (childLength === 0) childClass = 'empty';
  else if (childLength > 1) childClass = 'multiple';

  return (
    <li {...itemProps}>
      <div className={`nestable-item-name nestable-item-name--${item.element.type} `} {...rowProps}>
        {renderItem({
          item,
          handler: Handler,
          index,
        })}
      </div>
      {hasChildren && item.element.type === 'group' && !isCollapsed && (
        <ol className={`nestable-list nestable-child-count-${childClass} `}>
          {item[childrenProp].map((currentitem, i) => (
            <NestableItem
              key={i}
              index={i}
              isAndItem={isAndGroup}
              isCopy={isCopy}
              isOrItem={isOrGroup}
              item={currentitem}
              options={options}
              singleRow={singleRow}
            />
          ))}
        </ol>
      )}
    </li>
  );
};

export default NestableItem;
